export const HALF_CARD_ACTION = {
    CLOSE: "close",
    CTA: "cta",
};
